const columns = [
  {
    title: '内容分区',
    links: ['今日新料', '猛料速报', '事件内幕', '热门话题榜', '投稿与核实'],
  },
  {
    title: '阅读指南',
    links: ['事件状态说明', '来源标注规则', '澄清与更正机制', '隐私保护原则', '免责与版权'],
  },
  {
    title: '关于我们',
    links: ['站点介绍', '编辑团队', '联系方式', '媒体报道', '加入我们'],
  },
];

export default function Footer() {
  return (
    <footer className="mt-14 border-t border-stone-200 bg-[#f2efe9] md:mt-16">
      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="inline-flex items-center gap-2.5">
              <span className="grid h-9 w-9 place-items-center rounded-md bg-stone-950 text-white">
                <i className="ri-focus-3-fill text-lg" />
              </span>
              <span className="font-display text-xl font-black tracking-wide text-stone-950">网黑料</span>
            </a>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-stone-500">
              网黑料汇聚全网最新黑料与猛料，追踪今日新料与热门事件内幕。信息聚合门户，
              坚持标注来源与状态，让每一次爆料的来龙去脉都可查、可追、可更新。
            </p>
            <p className="mt-3 text-xs text-stone-400">
              本站为信息聚合演示页面，所展示话题均为演示语料，不作为事实认定，亦不代表编辑立场。
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-3 md:col-span-7">
            {columns.map((c) => (
              <div key={c.title}>
                <h4 className="text-sm font-semibold text-stone-800">{c.title}</h4>
                <ul className="mt-3 space-y-2">
                  {c.links.map((l) => (
                    <li key={l}>
                      <a href="#top" className="text-sm text-stone-500 transition-colors hover:text-red-600">
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-9 flex flex-col items-center justify-between gap-3 border-t border-stone-200 pt-5 sm:flex-row">
          <p className="text-xs text-stone-400">© 2026 网黑料 · 全网黑料 / 今日新料 / 猛料 / 快讯资讯聚合门户</p>
          <div className="flex items-center gap-1 text-stone-400">
            <i className="ri-focus-3-line" />
            <span className="text-xs">把新鲜的，留在表面</span>
          </div>
        </div>
      </div>
    </footer>
  );
}